<template>
    <div class="row mb-2">
        <div class="col d-flex justify-content-between border-bottom mx-3 p-0">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
  name: 'RouteHeader'
}
</script>
